import { request } from "@/api/request"

/** 收入明细列表（type：0定金 1首单 2UP 3REN 4英皇课 5杂费 6退费 7转中心退费） */
export function fetchIncomeDetailList(payload = {}) {
  return request.post("/mgm-crm-api/income-detail/list", payload).then(r => r.data)
}

export function fetchIncomeDetailSummary(payload = {}) {
  return request.post("/mgm-crm-api/income-detail/amount-stat", payload).then(r => r.data)
}

export function fetchIncomeDetail(id) {
  return request.get(`/mgm-crm-api/income-detail/detail/${id}`).then(r => r.data)
}

export function createIncomeDetail(payload = {}) {
  return request.post("/mgm-crm-api/income-detail/create", payload).then(r => r.data)
}

export function updateIncomeDetail(payload = {}) {
  return request.post("/mgm-crm-api/income-detail/update", payload).then(r => r.data)
}

export function deleteIncomeDetail(id) {
  return request.post(`/mgm-crm-api/income-detail/delete/${id}`, {}).then(r => r.data)
}
